import type { FaireProductEntity } from "../../entity_types/product";

export const p_8jz44654p5: FaireProductEntity = {
  token: "p_8jz44654p5",
  type: "product",
  name: "CHRISTMAS OPEN FRONT KNIT CARDIGAN WITH SCALLOPED EDGES",
  brandToken: "b_1taybicqc4",
  brandName: "BiBi",
  imageUrl:
    "https://cdn.faire.com/fastly/311c3e3d558e56d50114273e19295209e4d8e0d23481d7a8929dadf4d08217b2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/304fec8ea5e3a6a76c1d801ac78ec9fcec7c85b1c503015cd984dd803f3ac005.jpeg",
    "https://cdn.faire.com/fastly/651f7a19b8c448ef0956ea48c478d3982d3860b22545a4c2181dc95f46b0da0b.jpeg",
    "https://cdn.faire.com/fastly/7b151619ab3da5c5b8c1410e7b65665fc202fba1a2d93ea5a4d4b1dcc9f1a28b.jpeg",
    "https://cdn.faire.com/fastly/9ed332768103247c2591a679dc522ee813373d3dcba68465816c5f303ca24bfa.jpeg",
    "https://cdn.faire.com/fastly/0ae7f91d931e610a19b3da26e9dd4453b94c82bdc77f836d38f862f62a0c37e2.jpeg",
    "https://cdn.faire.com/fastly/9714a1ae93c0220d3bd8af750f33fd7981df3549e964d7f564d63527011bd708.jpeg",
  ],
  priceDollars: 159.6,
  description:
    "Elevate your holiday comfort with this classic, easy-to-wear cardigan. This cozy knit is perfect for staying warm and stylish. It features a timeless vertical stripe pattern in festive red, green, and cream. The unique scalloped trim gives it a charming, feminine touch, and the relaxed open-front design makes layering over any top simple and flattering. Ideal for all your seasonal gatherings, from dinner with family to holiday shopping. Give your wardrobe a boost with this sophisticated and warm holiday knit.",
  tags: [],
  msrpDollars: 319.2,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:24.055Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
